import Modal from '..';
import React from 'react';
import Iframe from '../../iframe';
import ControlBase from '../../base';
import { getIframeId } from '../utils';
import zhCN from 'antd/es/locale/zh_CN';
import { IModalState } from '../typings';
import IframeControl from '../../iframe/pc';
import ModalHelper from '@mjcloud/modal-helper';
import { Drawer, Modal as AntdModal, ConfigProvider } from 'antd';

import styles from './index.less';

class ModalControl extends ControlBase<IModalState, Modal> {
  private iframe: Iframe | null = null;
  private resizeTimeout: any = null;

  UNSAFE_componentWillMount() {
    window.addEventListener(
      'orientationchange' in window ? 'orientationchange' : 'resize',
      this.resizeThrottler,
      false,
    );
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener(
      'orientationchange' in window ? 'orientationchange' : 'resize',
      this.resizeThrottler,
      false,
    );
  }

  resizeThrottler = () => {
    // ignore resize events as long as an actualResizeHandler execution is in the queue
    if (!this.resizeTimeout) {
      this.resizeTimeout = setTimeout(() => {
        this.resizeTimeout = null;
        this.actualResizeHandler();
        // The actualResizeHandler will execute at a rate of 15fps
      }, 66);
    }
  };

  actualResizeHandler = () => {
    this.instance.store.dispatch('updateStyles', {});
  };

  private onCancel = () => {
    if (this.iframe) {
      const currentPage = this.iframe.currentPage;
      if (currentPage) currentPage.close();
    } else {
      ModalHelper.closeModal(this.state.id, { oper: 'cancel' });
    }
  };

  private onClose = () => {
    this.onCancel()
    setTimeout(() => {
     if (this.state.afterClose) this.state.afterClose()
    }, 0);
  }

  refIframeControl = (instance: IframeControl | null) => {
    if (instance) this.iframe = instance.instance;
  };

  renderContent() {
    const { id, top, title, visible, width, height, isDrawer, afterClose } = this.state;
    if (isDrawer) {
      return (
        <Drawer
          title={title}
          width={width}
          placement="right"
          style={{ top }}
          visible={visible}
          className={styles.tier}
          onClose={this.onClose}
          destroyOnClose
        >
          <ConfigProvider locale={zhCN}>
            <div id={id} className={styles.iframe} style={{ height }}>
              <IframeControl
                id={getIframeId(id)}
                ref={this.refIframeControl}
                parentId={this.instance.page.id}
                pageKey={this.instance.page.id}
              />
            </div>
          </ConfigProvider>
        </Drawer>
      );
    }
    return (
      <AntdModal
        title={title}
        width={width}
        style={{ top }}
        visible={visible}
        className={styles.tier}
        onCancel={this.onCancel}
        afterClose={afterClose}
        maskClosable={false}
        keyboard={false}
        destroyOnClose
        footer={null}
      >
        <ConfigProvider locale={zhCN}>
          <div id={id} className={styles.iframe} style={{ height }}>
            <IframeControl
              id={getIframeId(id)}
              ref={this.refIframeControl}
              parentId={this.instance.page.id}
              pageKey={this.instance.page.id}
            />
          </div>
        </ConfigProvider>
      </AntdModal>
    );
  }
}

export default ModalControl;
